"use client";

import React from "react";
import { message } from "antd";
import moment, { Moment } from "moment";
import { studentProgramAssistancesAcademy } from "../../../../shared/services";
import { AttendanceDailyRow } from "./useProgramAttendanceDaily";

export default function useSaveProgramAttendance(
  programId: number,
  selectedDate: Moment
) {
  const [saving, setSaving] = React.useState(false);

  const save = async (rows: AttendanceDailyRow[]) => {
    const pending = rows.filter((row) => row.dirty);
    if (!pending.length) {
      message.warning("No hay cambios para guardar");
      return false;
    }

    const incomplete = pending.filter((row) => !row.attendanceStatus);
    if (incomplete.length) {
      message.error(
        "Selecciona asistió o no asistió para todos los estudiantes con cambios pendientes"
      );
      return false;
    }

    const assistanceDate = selectedDate.clone().startOf("day").toISOString();
    setSaving(true);

    try {
      for (const row of pending) {
        if (row.recordId) {
          await studentProgramAssistancesAcademy.patch(row.recordId, {
            attendance_status: row.attendanceStatus,
            assistance_date: assistanceDate,
          });
        } else {
          await studentProgramAssistancesAcademy.create({
            user_id: row.userId,
            program_id: programId,
            program_student_id: row.programStudentId,
            assistance_date: assistanceDate,
            attendance_status: row.attendanceStatus,
          });
        }
      }

      message.success("Asistencia guardada correctamente");
      return true;
    } catch (err: any) {
      message.error(err?.message ?? "Error al guardar la asistencia");
      return false;
    } finally {
      setSaving(false);
    }
  };

  return { saving, save };
}
